// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import AnimValueProgress from "../../../../engines/components/animation/AnimValueProgress";
import O1HD from "../../../../engines/gameEngine";
import MathUtil from "../../../../engines/libs/MathUtil";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { GeneralKind } from "../../../define/GeneralKind";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant, getOneBundleOnePrefab } from "../../BundleResourceConfig";
import OrchardGoods from "./goodsItem/OrchardGoods";

const {ccclass, property} = cc._decorator;

const c_max_count = 3;
const c_updateNum = 0.016 * c_max_count;

/** 移动速度 */
const c_moveSpeed = 30 * c_max_count;
/** 旋转速度 */
const c_rotateSpeed = 100 * c_max_count;

const c_initWaterLen = 200;
/** 每帧消耗 */
const c_cosumeLen = 0.03;

const c_rorateLimit = 30;

const c_adAddLen = 200;
const c_adCount = 2;

const c_aniWaterAdd = c_cosumeLen * 10;

const c_totalHeiht = 201;
@ccclass
export default class OrchardOperateLayer extends BasePopUpLayer {

	@property({ type: cc.Node, displayName:'' })
	nodeStartHint: cc.Node = null;

	@property({ type: cc.Graphics, displayName:'' })
	nodeGraphicsWater: cc.Graphics = null;
	@property({ type: cc.Graphics, displayName:'' })
	nodeGraphicsBottom: cc.Graphics = null;

	@property({ type: cc.Node, displayName:'' })
	nodeGoodsList: cc.Node = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprSoil1: cc.Sprite = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprSoil2: cc.Sprite = null;
	@property({ type: cc.Sprite, displayName:'' })
	sprSoil3: cc.Sprite = null;

    @property(cc.Node)
    spr_root: cc.Node = null;
    
    @property(cc.Node)
    sprWater: cc.Node = null;
    
    @property(cc.Node)
    nodeList: cc.Node = null;
    @property(cc.Node)
    nodeViewRang: cc.Node = null;

    @property(cc.PolygonCollider)
    nodeWallLeft: cc.PolygonCollider = null;
    @property(cc.PolygonCollider)
    nodeWallRight: cc.PolygonCollider = null;

    @property(cc.Node)
    nodeWallTop: cc.Node = null;
    @property(cc.Node)
    nodeWallBottom: cc.Node = null;

    @property(AnimValueProgress)
    progressBar: AnimValueProgress = null;

    @property(cc.Node)
    nodeLenHint: cc.Node = null;

    @property(cc.Label)
    labelLenHint: cc.Label = null;

    private csvInfo = null;

    private bStart = false;
    private bStop = false;
    private moveAngle = -90;

    private lastRecordPos: cc.Vec2 = null;
    private curRecordPos: cc.Vec2 = null;

    private touches: cc.Vec2[] = [];

    private updateNum = 0;

    private curWaterLen = c_initWaterLen;
    

    private preNodeListPos: cc.Vec2 = null;

    private adCount = 0;
    private oriWaterHeight = 0;

    private waterLenAniResidue = 0;

    private oriStartPos: cc.Vec2 = null;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        O1HD.getModules().uiControlModule.hideLoading();

        this.oriWaterHeight = this.sprWater.height;
        this.oriStartPos = this.spr_root.getPosition().clone();
        this.progressBar.setValue(0, true, false);

        this.nodeStartHint.active = true;

        this.setProgressCallback();
        this.refreshProgressLen();
        this.refreshProgressUI();
        this.initTouchEvent(this.node);
        this.initLayer();
    }

    initLayer() {
        let id = this._carryData.id;

        this.csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.ORCHARD, id);
        if (!this.csvInfo) {
            console.error("csvInfo is null id = " + id);
            return;
        }

        this.initSoil();

        // let pos = this.nodeGraphicsBottom.node.getPosition();

        let pos = this.spr_root.getPosition().clone();
        this.nodeGraphicsBottom.moveTo(pos.x, pos.y);
        this.touches.push(pos);
        this.loadGoodsListPrefab();
    }

    initSoil() {
        let id = this._carryData.id;

        let path = 'res/oeprate/items/spr_soil_' + id;
        let pathBottom = 'res/oeprate/items/spr_soil_' + id + '_bottom';
        getOneBundleByInstant(BUNDLE_SMALL_NAME.orchardBundle).load(path, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    this.sprSoil1.spriteFrame = imgs;
                }
            }
        );
        getOneBundleByInstant(BUNDLE_SMALL_NAME.orchardBundle).load(path, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    this.sprSoil3.spriteFrame = imgs;
                }
            }
        );
        getOneBundleByInstant(BUNDLE_SMALL_NAME.orchardBundle).load(pathBottom, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    this.sprSoil2.spriteFrame = imgs;
                }
            }
        );
    }

    loadGoodsListPrefab() {
        let path = 'prefab/goodsPos/' + this.csvInfo.goods_pos;
        let self = this;
        getOneBundleOnePrefab(BUNDLE_SMALL_NAME.orchardBundle, path, false).then(function(prefab){
            if (!prefab) {
                console.error(`加载预制体失败 path = ${path}`);
                return;
            }

            let posList: cc.Vec2[] = [];
            prefab.data.children.forEach((v)=> {
                posList.push(v.convertToWorldSpaceAR(cc.v2()));
            });

            self.initGoods(posList);
        });
    }

    initGoods(posList: cc.Vec2[]) {
        let may_goods = utilsModel.splitLineFeed(this.csvInfo.may_goods);
        let goods_weight = utilsModel.splitLineFeed(this.csvInfo.goods_weight);
        
        let idList = utilsModel.getWeightsIdxList(goods_weight, posList.length);
        let self = this;
        for (let i = 0; i < posList.length; i++) {
            let goodsPath = 'prefab/operateItems/' + may_goods[idList[i]];
            let pos = this.nodeGoodsList.convertToNodeSpaceAR(posList[i]);

            getOneBundleOnePrefab(BUNDLE_SMALL_NAME.orchardBundle, goodsPath, false).then(function(prefab){
                if (!prefab) {
                    console.error(`加载预制体失败 path = ${goodsPath}`);
                    return;
                }
    
                let nodeItem = cc.instantiate(prefab);
                let sc = nodeItem.getComponent(OrchardGoods);
                sc.setCarryData({parent: self});
                nodeItem.parent = self.nodeGoodsList;
                nodeItem.setPosition(pos);
            });
        }
    }

    touchEventStart(event: cc.Event.EventTouch){
        
    }

    touchEventMove(event: cc.Event.EventTouch){
        if (!this.bStart) {
            return;
        }

        let local = this.curRecordPos = event.getLocation();
        if (!this.lastRecordPos) {
            this.lastRecordPos = local;
        }
    }

    touchEventEnd(event: cc.Event.EventTouch){
        // this.bStart = false;
    }

    touchEventCancel(event: cc.Event.EventTouch){
        // this.bStart = false;
    }

    gameEnd() {

        this.adCount++;
        if (this.adCount > c_adCount) {

        }
        this.bStart = false;
        utilsView.openPopupLayer(
            'prefab/OrchardSupplementWaterLayer'
            , BUNDLE_SMALL_NAME.orchardBundle
            , this.node
            , {
                parent: this
            }
        );
    }

    reveiveLen() {
        this.waterLenAniResidue = 0;
        this.sprWater.height = this.oriWaterHeight;
        this.bStart = true;
        this.curWaterLen = c_adAddLen;
    }

    protected update(dt: number): void {
        if (!this.bStart || this.bStop) {
            return;
        }

        if (this.waterLenAniResidue > 0) {
            let al = Math.min(c_aniWaterAdd, this.waterLenAniResidue)
            this.waterLenAniResidue = Math.max(this.waterLenAniResidue - al, 0);
            this.addWaterLen(al);
        } else if (this.waterLenAniResidue < 0) {
            let al = Math.min(c_aniWaterAdd, -this.waterLenAniResidue)
            this.waterLenAniResidue = Math.min(this.waterLenAniResidue + al, 0);
            this.addWaterLen(-al);
        }

        // cc.macro.ENABLE_WEBGL_ANTIALIAS = true;
        let dtTmp = this.updateNum += dt;
        this.curWaterLen -= c_cosumeLen;
        if (this.updateNum < c_updateNum) {
            this.graphicsWaterLine();
            this.updateWater();
            return;
        }
        this.updateNum = 0;
        // if (this.curWaterLen < 0) {
        //     this.updateWater();
        //     return;
        // }

        if (this.curRecordPos && this.lastRecordPos && this.lastRecordPos.sub(this.curRecordPos).mag() > c_rorateLimit) {
            this.moveAngle = (MathUtil.getAngle2(this.curRecordPos, this.lastRecordPos) + 3600 + 180) % 360;
            this.lastRecordPos = this.curRecordPos;
        }
        
        this.movePosAngle(dtTmp);
        this.graphicsBottomLine();
        this.graphicsWaterLine();
        this.updateWater();
    }

    graphicsBottomLine() {
        let rootPos = this.spr_root.getPosition();
        let lastPos: cc.Vec2 = null;
        if (this.touches.length > 0) {
            lastPos = this.touches[this.touches.length - 1];
        }
        if (!lastPos || !lastPos.equals(rootPos)) {
            this.touches.push(rootPos);
        }
        this.nodeGraphicsBottom.clear();
        for (let i = 0; i < this.touches.length; i++) {
            let pos = this.touches[i];
            if (i == 0) {
                this.nodeGraphicsBottom.moveTo(pos.x, pos.y);
            } else {
                this.nodeGraphicsBottom.lineTo(pos.x, pos.y);
            }
        }
        this.nodeGraphicsBottom.stroke();
    }

    graphicsWaterLine() {
        this.nodeGraphicsWater.clear();
        if (this.curWaterLen <= 0) {
            return;
        }

        // let waterMax = this.touches.length-1;
        let curDis = 0;
        let posList: cc.Vec2[] = [];
        for (let i = this.touches.length-1; i >= 1; i--) {
            let p1 = this.touches[i];
            let p2 = this.touches[i-1];
            curDis += p1.sub(p2).mag();
            if (curDis > this.curWaterLen) {
                let d = (curDis - this.curWaterLen);
                let a = MathUtil.getAngle2(p2, p1);
                let ePos = MathUtil.getTargetPosFromAngleDistance(p1, d, a);
                posList.push(ePos);
                break;
            }
            // waterMax = i;
            posList.push(p1);
        }

        let j = 0;
        for (let i = posList.length - 1; i >= 0; i--) {
            let pos = posList[i];
            if (j == 0) {
                this.nodeGraphicsWater.moveTo(pos.x, pos.y);
            } else {
                this.nodeGraphicsWater.lineTo(pos.x, pos.y);
            }
            j++;
        }
        this.nodeGraphicsWater.stroke();
    }

    updateWater() {
        if (this.curWaterLen > 0) {
            return;
        }
        let height = this.sprWater.height - c_cosumeLen;
        if (height <= 0) {
            height = 0;
        }
        this.sprWater.height = height;
        if (height <= 0) {
            this.gameEnd();
        }
    }

    isCollide(self: cc.Node, other: cc.PolygonCollider, endPos: cc.Vec2) {
        let selfPolygon = self.getComponent(cc.PolygonCollider);
        let addPos = cc.v2(endPos.x - self.x, endPos.y - self.y);
        let points: cc.Vec2[] = [];
        for (let i = 0; i < selfPolygon.points.length; i++) {
            let p = self.convertToWorldSpaceAR(cc.v2(selfPolygon.points[i].x + addPos.x + selfPolygon.offset.x, selfPolygon.points[i].y + addPos.y + selfPolygon.offset.y));
            p = other.node.convertToNodeSpaceAR(p);
            p.x -= other.offset.x;
            p.y -= other.offset.y; 
            points.push(p);
        }
        let bCollide = cc.Intersection.polygonPolygon(points, other.points);
        return bCollide;
    }

    movePosAngle(dt: number) {
        let moveDis = dt * c_moveSpeed;
        let sPos = this.spr_root.getPosition();
        let curAngle = (this.spr_root.angle - 90 + 3600) % 360;
        let eAngle = curAngle;

        if (eAngle != this.moveAngle) {
            let spaceAng = (this.moveAngle - eAngle + 3600) % 360;

            if (spaceAng > 180) {
                spaceAng = spaceAng - 360;
            }
            if (spaceAng > 0) {
                spaceAng = Math.min(c_rotateSpeed * dt, spaceAng);
                eAngle = curAngle + spaceAng;
            } else {
                spaceAng = Math.max(-c_rotateSpeed * dt, spaceAng);
                eAngle = curAngle + spaceAng;
            }
        }

        this.spr_root.angle = eAngle + 90;
        // cc.log('-- 角度 ', eAngle, this.spr_root.angle, this.moveAngle)

        let ePos = MathUtil.getTargetPosFromAngleDistance(sPos, moveDis, eAngle);
        // 碰撞检测  墙体
        let bCompareLeft = false;
        let bCompareRight = false;
        let bCompareTop = false;
        let bCompareBottom = false;
        let prePos = this.spr_root.getPosition().clone();
        if (ePos.x > 375 || ePos.y < -675) {
            bCompareRight = true;
        }

        if (ePos.x < -375 || ePos.y < -675) {
            bCompareLeft =  true;
        }

        if (ePos.y > 50) {
            bCompareTop = true;
        } else if (ePos.y < -675) {
            bCompareBottom = true;
        }

        if (bCompareLeft) {
            if (this.isCollide(this.spr_root, this.nodeWallLeft, ePos)) {
                return;
            }
        }

        if (bCompareRight) {
            if (this.isCollide(this.spr_root, this.nodeWallRight, ePos)) {
                return;
            }
        }

        if (bCompareTop) {
            let topPos = this.spr_root.parent.convertToNodeSpaceAR(this.nodeWallTop.convertToWorldSpaceAR(cc.v2()));
            if (ePos.y >= topPos.y) {
                ePos.y = prePos.y;
            }
        }
        if (bCompareBottom) {
            let topPos = this.spr_root.parent.convertToNodeSpaceAR(this.nodeWallBottom.convertToWorldSpaceAR(cc.v2()));
            if (ePos.y <= topPos.y) {
                ePos.y = prePos.y;
            }
        }

        if (ePos.x == prePos.x && ePos.y == prePos.y) {
            return;
        }

        if (!this.goodsCollide(ePos)) {
            return;
        }

        this.spr_root.setPosition(ePos);
        this.refreshProgressLen();
        
        let winSize = cc.winSize;
        let wPos = this.spr_root.convertToWorldSpaceAR(cc.v2());
        let viewWPos = this.nodeViewRang.convertToWorldSpaceAR(cc.v2());
        let movePos = cc.v2(0,0);
        if (wPos.x > (winSize.width * 2/3)) {
            // 往右
            if ((viewWPos.x + this.nodeViewRang.width) > winSize.width) {
                let mx = Math.min(viewWPos.x + this.nodeViewRang.width - winSize.width, ePos.x - prePos.x);

                movePos.x = -mx;
            }
        } else if (wPos.x < (winSize.width * 1/3)) {
            // 往左
            if (viewWPos.x < 0) {
                let mx = Math.min(0 - viewWPos.x, prePos.x - ePos.x);
                movePos.x = mx;
            }
        }

        if (wPos.y > (winSize.height * 1/2)) {
            // 往上
            if (this.nodeList.y > 0) {
                let my = Math.min(this.nodeList.y, ePos.y - prePos.y);
                if (my > 0) {
                    movePos.y = -my;
                }
                
            }
        } else if (wPos.y < (winSize.height * 1/4)) {
            // 往下
            if ((viewWPos.y - this.nodeViewRang.height) < 0) {
                let mx = Math.min(this.nodeViewRang.height - viewWPos.y, prePos.y - ePos.y);
                if (mx > 0) {
                    movePos.y = mx;
                }
            }
        }

        if (movePos.x != 0 || movePos.y != 0) {
            this.nodeList.stopAllActions();
            if (this.preNodeListPos) {
                this.nodeList.setPosition(this.preNodeListPos);
            }
            this.preNodeListPos = movePos.add(this.nodeList.getPosition());
            cc.tween(this.nodeList)
            .by(c_updateNum - 0.002, {
               x: movePos.x, y: movePos.y 
            })
            .start();
        }
    }

    refreshProgressLen() {
        let d = this.nodeWallTop.y - this.spr_root.y;
        let tH = this.nodeWallTop.y - this.nodeWallBottom.y;
        let p = Math.max(0, d / tH);
        let l = Math.floor(p * c_totalHeiht);
        this.progressBar.setValue(p, true, true);
        this.labelLenHint.string = l + '米';
    }

    setProgressCallback() {
        this.progressBar.setCallback(()=> {
            this.refreshProgressUI();
        });
    }

    refreshProgressUI() {
        let h = this.progressBar.node.height * this.progressBar.curValue;
        this.nodeLenHint.y = -h;
    }

    goodsCollide(ePos: cc.Vec2) {
        let children = this.nodeGoodsList.children;
        for (let o of children) {
            let sc = o.getComponent(OrchardGoods);
            if (!sc.isGoodsValid()) {
                continue;
            }
            if (this.isCollide(this.spr_root, o.getComponent(cc.PolygonCollider)
            , ePos)) 
            {
                sc.collideEffect();

                if (!sc.isCanaCross()) {
                    return false;
                }

                let wL = sc.getAddWaterLen();
                if (wL != 0) {
                    this.addWaterLenAni(wL);
                }
                break;
            }
        }
        return true;
    }

    setStop(stop: boolean) {
        this.bStop = stop;
    }

    addWaterLenAni(len: number) {
        this.waterLenAniResidue += len;
        if (!this.bStart) {
            this.waterLenAniResidue = 0;
        }
    }

    addWaterLen(len: number) {
        if (len == 0) {
            return;
        }

        if (len > 0) {
            if (this.curWaterLen <= 0) {
                let d = this.oriWaterHeight - this.sprWater.height;
                if (len <= d) {
                    this.sprWater.height += len;
                } else {
                    this.sprWater.height = this.oriWaterHeight;
                    len -= d;
                    this.curWaterLen = len;
                }
            } else {
                this.curWaterLen += len;
            }
        } else {
            if (this.curWaterLen <= 0) {
                let el = Math.max(0, this.sprWater.height + len);
                this.sprWater.height = el;
            } else {
                if (-len > this.curWaterLen) {
                    let d = this.curWaterLen + len;
                    this.curWaterLen = 0;

                    let el = Math.max(0, this.sprWater.height + d);
                    this.sprWater.height = el;
                } else {
                    this.curWaterLen += len;
                }
            }
        }
    }

    onClickStart() {
        this.nodeStartHint.active = false;
        this.bStart = true;
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
    }

    // update (dt) {}
}
